<template>

    <div class="py-4 container-fluid">
    <div class="mt-4 row">
      <div class="col-12"> 
        <div class="card">
          <div class="card-header border-bottom">
            <div class="user d-flex align-items-center">
              <div class="col-6">
                <h5 class="mb-0">Guest Users</h5>
              </div>
            </div>
          </div>

          <div class="table-responsive">
            <table id="datatable-search-guest" class="table table-flush table-bordered">
              <thead class="thead-light">
                <tr>
                  <th>Name</th>
                  <th>Email</th>
                  <th>VBot ID</th>
                  <th>Created At</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="guests.length === 0">
                  <td colspan="5" class="text-center">No guests found.</td>
                </tr>
                <tr v-for="guest in guests" :key="guest.id">
                  <td>{{ guest.name }}</td>
                  <td>{{ guest.email }}</td>
                  <td>{{ guest.vbot_id }}</td>
                  <td>{{ formatDate(guest.created_at) }}</td>
                  <td>
                    <button @click="editGuestUser(guest.id)" class="btn btn-primary btn-sm">Passwort ändern</button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="py-4 container-fluid">
    <div class="mt-4 row">
      <div class="col-12">
        <div class="card">
          <div class="card-header border-bottom">
            <div class="user d-flex align-items-center">
              <div class="col-6">
                <h5 class="mb-0">Phonebots</h5>
              </div>
            </div>
          </div>

          <div class="table-responsive">
            <table id="datatable-search" class="table table-flush">
              <thead class="thead-light">
                <tr>
                  <th>#</th>
                  <th>Guest Name</th>
                  <th>Phonebot</th>
                  <th>License/UserKey</th>
                  <th>Open AI Key</th>
                  <th>Mistral Key</th>
                  <th>Status</th>
                  <th>Created At</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="vbots.length === 0">
                  <td colspan="9" class="text-center">No Phonebots found.</td>
                </tr>
                <tr v-for="vbot in vbots" :key="vbot.id">
                  <td>{{ getVbotIndex(vbot) + 1 }}</td>
                  <td>{{ vbot.customer_name }}</td>
                  <td>{{ vbot.bezeichnung }}</td>
                  <td>{{ vbot.license_Key }}</td>
                  <td>{{ maskApiKey(vbot.apen_ai_key) }}</td>
                  <td>{{ maskApiKey(vbot.mistral_api_key) }}</td>
                  <td>{{ vbot.pstatus }}</td>
                  <td>{{ formatDate(vbot.created_at) }}</td>
                  <td>
                    <button class="btn btn-sm btn-info" @click="editItem(vbot.license_Key)">
                      <i class="fas fa-pen"></i>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>


</template>

<script>
import $ from 'jquery';
import 'datatables.net-bs5';
import 'datatables.net-bs5/css/dataTables.bootstrap5.min.css';
import guestService from "@/services/guest.service";

export default {
  name: 'GuestManagement',
  data() {
    return {
      vbots: [],
      guests: [],
      dataTable: null,
      dataTableGuest: null,
    };
  },

  async mounted() {
    await this.fetchData();
  },

  methods: {
    maskApiKey(text) {
      const safeText = text || '';
      return safeText.length > 10 ? safeText.substring(0, 20) + '...' : safeText;
    },

    getVbotIndex(vbot) {
      if (Array.isArray(this.vbots)) {
        return this.vbots.indexOf(vbot);
      }
      return -1;
    },

    async fetchData() {
      try {
        const response = await guestService.getGuest();
        
        // Ensure we have arrays, even if empty
        this.vbots = Array.isArray(response.vbots) ? response.vbots : [];
        this.guests = Array.isArray(response.guests) ? response.guests : [];
        
        // Wait for DOM update before initializing tables
        await this.$nextTick();
        
        if (this.dataTable === null) {
          this.initializeDataTable();
        } else {
          this.refreshDataTable();
        }
        
        if(this.dataTableGuest === null){
          this.initializeGuestDataTable();
        } else {
          this.refreshGuestDataTable();
        }
      } catch (error) {
        console.error("Error fetching data:", error);
        // Initialize empty tables on error
        this.vbots = [];
        this.guests = [];
        await this.$nextTick();
        if (this.dataTable === null) {
          this.initializeDataTable();
        }
        if (this.dataTableGuest === null) {
          this.initializeGuestDataTable();
        }
      }
    },

    formatDate(dateString) {
      const date = new Date(dateString);
      const formattedDate = date.toISOString().split('T')[0];
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      const formattedTime = `${hours}:${minutes}`;
      return `${formattedDate},${formattedTime}`;
    },

    editItem(license_Key) {
      this.$router.push({ name: 'EditPhonebot', params: { license_Key: license_Key } });
    },

    initializeDataTable() {
      this.$nextTick(() => {
        // Ensure table exists
        if (!$('#datatable-search').length) {
          console.error('DataTable element not found');
          return;
        }

        if ($.fn.DataTable.isDataTable('#datatable-search')) {
          $('#datatable-search').DataTable().destroy();
        }

        // Only initialize if we have data structure
        this.dataTable = $('#datatable-search').DataTable({
          data: this.vbots,
          columns: [
            { 
              data: null,
              defaultContent: '',
              render: (data, type, row, meta) => {
                return meta.row + 1;
              }
            },
            { data: 'customer_name', defaultContent: '-' },
            { data: 'bezeichnung', defaultContent: '-' },
            { data: 'license_Key', defaultContent: '-' },
            { data: 'apen_ai_key', defaultContent: '-' },
            { data: 'mistral_api_key', defaultContent: '-' },
            { data: 'pstatus', defaultContent: '-' },
            {
              data: 'created_at',
              defaultContent: '-',
              render: (data) => {
                return data ? this.formatDate(data) : '-';
              }
            },
            {
              data: null,
              defaultContent: '',
              render: (data) => {
                return `<button class='btn btn-info btn-sm edit-btn' data-id='${data.license_Key || ''}'>Edit</button>`;
              },
            },
          ],
          drawCallback: () => {
            this.applyCustomBorders();
          },
        });

        $('#datatable-search tbody').on('click', '.edit-btn', (event) => {
          const license_Key = $(event.currentTarget).data('id');
          if (license_Key) {
            this.editItem(license_Key);
          }
        });

        this.applyCustomBorders();
      });
    },

    initializeGuestDataTable() {
      this.$nextTick(() => {
        // Ensure table exists
        if (!$('#datatable-search-guest').length) {
          console.error('Guest DataTable element not found');
          return;
        }

        if ($.fn.DataTable.isDataTable('#datatable-search-guest')) {
          $('#datatable-search-guest').DataTable().destroy();
        }

        this.dataTableGuest = $('#datatable-search-guest').DataTable({
          paging: true,
          searching: true,
          info: true,
          data: this.guests,
          columns: [
            { data: 'name', defaultContent: '-' },
            { data: 'email', defaultContent: '-' },
            { data: 'vbot_id', defaultContent: '-' },
            {
              data: 'created_at',
              defaultContent: '-',
              render: data => data ? this.formatDate(data) : '-'
            },
            {
              data: null,
              defaultContent: '',
              render: (data, type, row) => {
                return `<button class='btn btn-primary btn-sm edit-guest-btn' data-id='${row.id || ''}'>Passwort ändern</button>`;
              }
            }
          ],
          drawCallback: () => {
            // Re-attach event listeners after each draw
            $('#datatable-search-guest tbody').off('click', '.edit-guest-btn');
            $('#datatable-search-guest tbody').on('click', '.edit-guest-btn', (event) => {
              const guestId = $(event.currentTarget).data('id');
              if (guestId) {
                this.editGuestUser(guestId);
              }
            });
            this.applyCustomBorders();
          }
        });
      });
    },

    refreshDataTable() {
      if (this.dataTable) {
        this.dataTable.clear().rows.add(this.vbots).draw();
      }
    },

    refreshGuestDataTable() {
      if (this.dataTableGuest) {
        this.dataTableGuest.clear().rows.add(this.guests).draw();
      }
    },

    editGuestUser(guestId) {
      const encodedId = btoa(guestId.toString());
      this.$router.push({ name: 'EditGuest', params: { id: encodedId } });
    },

    applyCustomBorders() {
      $('#datatable-search th, #datatable-search td, #datatable-search-guest th, #datatable-search-guest td').css({
        'border': '1px solid #ddd',
        'padding': '10px',
      });

      $('#datatable-search td:first-child, #datatable-search th:first-child, #datatable-search-guest td:first-child, #datatable-search-guest th:first-child').css({
        'border-left': '2px solid #ddd',
      });

      $('#datatable-search th, #datatable-search-guest th').css({
        'border-top': '2px solid #ddd',
      });
    },
  },
};
</script>

<style scoped>
#datatable-search, #datatable-search-guest {
  table-layout: fixed;
  width: 100%;
}

#datatable-search td button, #datatable-search-guest td button {
  margin-right: 5px;
}
</style>